<template>
  <div>
    <a-modal
      v-model:visible="visible"
      title="Editar holding"
      :closable="!loading"
      :maskClosable="!loading"
    >
      <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
        <a-form-item
          ref="name"
          label="Nombre o razón social holding"
          name="name"
          has-feedback
        >
          <a-input
            v-model:value="formState.name"
            placeholder="Ingresa un nombre"
          />
        </a-form-item>
        <a-form-item ref="rut" label="RUT Holding" name="rut" has-feedback>
          <a-input v-model:value="formState.rut" placeholder="Ingresa el RUT" />
        </a-form-item>
      </a-form>

      <template #footer>
        <a-button :disabled="loading" @click="closeModal">Cancelar</a-button>
        <a-button type="primary" @click="onOk" :loading="loading">
          Agregar
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { reactive, ref } from 'vue';
import { useStore } from 'vuex';
import modulo11 from '@/utils/rut';
import formatRut from '@/utils/formatRut';
import { PUT_HOLDING_EDIT } from '@/store/types';
import notification from '@/utils/notifications';

export default {
  name: 'HoldingEditionModal',
  setup(_, { emit }) {
    // * Variables
    const visible = ref(false);
    const loading = ref(false);
    const holding_id = ref(0);
    const store = useStore();

    // * Funciones Modal
    const openModal = (hold) => {
      const { holdingName, rutHolding, id } = hold;
      holding_id.value = id;
      formState.name = holdingName;
      formState.rut = rutHolding;
      visible.value = true;
    };

    const closeModal = () => {
      visible.value = false;
    };

    const checkRut = async (rule, value) => {
      if (!value) {
        return Promise.reject('Ingrese RUT');
      }
      if (modulo11(value)) {
        return Promise.resolve();
      }
      return Promise.reject('RUT no válido');
    };

    const onOk = () => {
      validateHoldingForm();
    };

    // * Form
    const formRef = ref();
    const formState = reactive({
      name: '',
      rut: ''
    });
    const rules = {
      name: [
        {
          required: true,
          message: 'Ingrese nombre',
          trigger: 'change'
        }
      ],
      rut: [
        {
          required: true,
          validator: checkRut,
          trigger: 'change'
        }
      ]
    };

    const editHolding = async (values) => {
      loading.value = true;
      try {
        const holding_obj = {
          rut: formatRut(values.rut),
          businessName: values.name
        };

        await store.dispatch(PUT_HOLDING_EDIT, {
          id: holding_id.value,
          payload: holding_obj
        });

        notification('success', 'Correcto', 'Holding Editado.');
        closeModal();
        emit('holdingEdited', true);
      } catch (error) {
        notification('error', 'Error', error.response.data.message);
      }
      loading.value = false;
    };

    const validateHoldingForm = async () => {
      try {
        const validation = await formRef.value.validate();
        editHolding(validation);
      } catch (error) {
        console.error(error);
      }
    };

    return {
      visible,
      formRef,
      formState,
      rules,
      loading,
      closeModal,
      onOk,
      openModal
    };
  }
};
</script>
